export default function NYEscan(){
    return (
        <>
            <img src='scan-nye-front.jpg'  style={{maxWidth:'100%'}} />
            <br/><br/>
            <img src='scan-nye-back.jpg'  style={{maxWidth:'100%'}} />

        </>
    )
}